export default __webpack_public_path__ + "68c9e7ed7c8e30c92eeda36647f980a5.js";